module.exports = __webpack_public_path__ + "img/hk_asahiyama.167692b1.png";